import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/www/fiction/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { addUser, getUsers, deleteUser, modifyUser } from '../../api/user'
import { categorylist } from "../../api/classification";
export default {
  name: 'basetable',
  data: function data() {
    return {
      query: {
        id: '',
        english: '',
        name: ''
      },
      page: 1,
      // 页码
      limit: 10,
      // 页容量
      total: 0,
      // 总条数
      tableData: [],
      // 请求的数据
      multipleSelection: [],
      delList: [],
      editVisible: false,
      // 编辑用户form
      form: {
        name: '',
        password: ''
      },
      // 添加用户表单验证规则对象
      TheEditor: {
        name: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }, {
          min: 3,
          max: 10,
          message: '长度在 3 到 10 个字符',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }, {
          min: 6,
          max: 13,
          message: '长度在 6 到 13 个字符',
          trigger: 'blur'
        }]
      },
      idx: -1,
      id: -1,
      pageTotal: 0,
      // 总条数
      addDialogVisible: false,
      // 控制添加用户对话框是否显示
      abc: {},
      // 获取用户信息
      // 添加用户的表单数据
      addForm: {
        name: '',
        email: '',
        password: ''
      },
      // 添加用户表单的验证规则对象
      addFormRules: {
        name: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }, {
          min: 3,
          max: 10,
          message: '长度在 3 到 10 个字符',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error('邮箱不能为空'));
              return;
            } // 邮箱的正则


            var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;

            if (!reg.test(value)) {
              return callback(new Error('邮箱不合法!'));
            }

            callback();
          }
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }, {
          min: 6,
          max: 13,
          message: '长度在 6 到 13 个字符',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getData();
  },
  methods: {
    // 获取用户信息
    getData: function () {
      var _getData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return categorylist();

              case 2:
                res = _context.sent;
                console.log(res);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    // 删除操作
    handleDelete: function handleDelete(id) {
      var _this = this;

      console.log(id); // 二次确认删除

      this.$confirm('您确定要永久删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return deleteUser({
                  id: id
                });

              case 2:
                res = _context2.sent;
                console.log(res);

                if (res.code === 0) {
                  _this.$message.success('删除成功~');

                  _this.getData();
                } else if (res.code === 1) {
                  _this.$message.error('删除失败~');
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))).catch(function () {}); // deleteUser(this.query).then(res => {
      //     console.log(res)
      // })
    },
    // 多选操作
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 编辑操作
    handleEdit: function handleEdit(index, row) {
      this.idx = index;
      this.form = row;
      this.editVisible = true;
    },
    // 保存编辑
    saveEdit: function saveEdit() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        console.log(valid);
        if (!valid) return; // 可以发起添加用户的网络请求

        modifyUser(_this2.form).then(function (res) {
          console.log(res);

          if (res.code == 0) {
            _this2.$message.success('编辑用户成功'); // 隐藏添加用户的对话框


            _this2.editVisible = false; // 重新发起请求用户列表

            _this2.getData();
          }
        });
      }); // this.editVisible = false
      // this.$message.success(`修改第 ${this.idx + 1} 行成功`)
      // this.$set(this.tableData, this.idx, this.form)
    },
    handleSizeChange: function handleSizeChange(val) {
      this.page = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.page = val;
      this.getData();
    },
    // 监听 添加用户对话框的关闭事件
    addDialogClosed: function addDialogClosed() {
      // 表单内容重置为空
      this.$refs.addFormRef.resetFields();
    },
    // 点击按钮 添加新用户
    NewUsers: function NewUsers() {
      var _this3 = this;

      this.$refs.addFormRef.validate(function (valid) {
        console.log(valid);
        if (!valid) return; // 可以发起添加用户的网络请求

        addUser(_this3.addForm).then(function (res) {
          console.log(res);

          if (res.code == 0) {
            _this3.$message.success('添加用户成功'); // 隐藏添加用户的对话框


            _this3.addDialogVisible = false; // 重新发起请求用户列表

            _this3.getData();
          } else if (res.code == 3) {
            _this3.$message.error('添加用户数失败');
          }
        });
      });
    },
    // 编辑用户
    EditTheUser: function EditTheUser() {
      this.$refs.form.resetFields();
    }
  }
};